import * as React from "react";
import { format, parseISO } from "date-fns";
import { IoAddOutline } from "react-icons/io5";
import { Button, Link, PageHeader, Table, Wrapper } from "components";
import { useQueryParams } from "duck";
import { Fragments, useDeleteOrderMutation, useGetOrdersQuery } from "requests";

const List: React.FC = () => {
  const [params] = useQueryParams();
  const { data, loading, refetch } = useGetOrdersQuery({
    fetchPolicy: "cache-and-network",
    variables: { page: params.pagination?.page || 1, perPage: 15 }
  });
  const [deleteOrder] = useDeleteOrderMutation({ ignoreResults: true });

  return (
    <>
      <PageHeader
        title="Order Management"
        actions={
          <Button to="./create" as={Link} leftIcon={<IoAddOutline />}>
            New Order
          </Button>
        }
      />
      <Wrapper withPadding={false} mt={6}>
        <Table
          data={data?.orders?.collection || []}
          loading={loading}
          totalCount={data?.orders?.paginationInfo.totalCount || 0}
          perPage={15}
        >
          <Table.Column label="Order ID" dataKey="_id" />
          <Table.Column<Fragments.Order["license"]>
            label="License Type"
            dataKey="license"
            render={({ value }) => value.name}
          />
          <Table.Column<Fragments.Order["organization"]>
            label="Organization"
            dataKey="organization"
            render={({ value }) => value.name}
          />
          <Table.Column<string>
            label="Start Date"
            dataKey="startDate"
            render={({ value }) => format(parseISO(value), "MM/dd/y")}
          />
          <Table.Column<string>
            label="Expiration Date"
            dataKey="expirationDate"
            render={({ value }) => format(parseISO(value), "MM/dd/y")}
          />
          <Table.Column<number, Fragments.Order>
            label="Actions"
            w="108px"
            dataKey="_id"
            render={({ value, record }) => (
              <Table.Actions
                editURL={`/order-management/${value}/edit`}
                deleteTitle={`Delete Order for ${record.organization.name}`}
                onDelete={toast =>
                  deleteOrder({ variables: { id: value } })
                    .then(() => refetch())
                    .then(() => {
                      toast("Order is deleted successfully.");
                    })
                }
              />
            )}
          />
        </Table>
      </Wrapper>
    </>
  );
};

export default List;
